import { render, staticRenderFns } from "./RefetchStatsDialog.vue?vue&type=template&id=236f694d"
import script from "./RefetchStatsDialog.vue?vue&type=script&lang=js"
export * from "./RefetchStatsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports